<template>
	<div class="row">
		<div class="col-12">
			<slot></slot>
		</div>
		<div class="col-12">
			<div class="d-flex">
				<div class="form-group custom-form-check mt-1 mb-0 d-inline-block me-2">
					<input :id="idElYes" class="checkbox-custom" name="chk-yes" type="checkbox" v-model="choice.checkY" @change.prevent="cangeStatusY">
					<label :for="idElYes" class="checkbox-custom-label fs-0-7 xsmall-text">
						<span class="fs-0-7">SÌ</span>
					</label>
				</div>
				<div class="form-group custom-form-check mt-1 mb-0 ms-2 d-inline-block">
					<input :id="idElNo" class="checkbox-custom" name="chk-no" type="checkbox" v-model="choice.checkN" @change.prevent="cangeStatusN">
					<label :for="idElNo" class="checkbox-custom-label fs-0-7 xsmall-text">
						<span class="fs-0-7">NO</span>
					</label>
				</div>
			</div>
		</div>
		<div class="col-12 fs-0-7 text-red" v-if="errorString" v-html="errorString"></div>
	</div>
</template>

<script>
export default {
	name: 'DoubleExlusiveCheckbox',
	props: {
		htmlText: {
			type: String,
			default: ''
		},
		htmlError: {
			type: String,
			default: ''
		},
		reset: {
			type: Boolean,
			default: false
		},
		idElYes: {
			type: String,
			default: ''
		},
		idElNo: {
			type: String,
			default: ''
		}
	},
	watch: {
		htmlError(newVal) {
			this.errorString = newVal
		},
		reset(neVal) {
			if(neVal === true) {
				this.choice = {
					checkY: false,
					checkN: false
				}
			}
		}
	},
	data() {
		return {
			choice: {
				checkY: false,
				checkN: false
			},
			errorString: this.htmlError
		}
	},
	methods: {
		cangeStatusY() {
			this.errorString = ''
			if(this.choice.checkY) {
				this.choice.checkN = false
			}
			this.$emit('sendValues', this.choice)
		},
		cangeStatusN() {
			this.errorString = ''
			if(this.choice.checkN) {
				this.choice.checkY = false
			}
			this.$emit('sendValues', this.choice)
		}
	}
}
</script>

<style scoped>
	custom+.checkbox-custom-label:before, .radio-custom+.radio-custom-label:before {
		content: "";
		background-color: #acc43526;
		border: 2px solid #acc435;
		border-radius: 50%;
		display: inline-block;
		vertical-align: middle;
		font-size: .9rem;
		width: 22px;
		height: 22px;
		padding: 2px;
		margin-right: 10px;
		margin-bottom: 2em;
		text-align: center;
		float: left;
	}
</style>
